"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchHierarchyRequest = fetchHierarchyRequest;
exports.fetchHierarchySuccess = fetchHierarchySuccess;
exports.fetchHierarchyFailure = fetchHierarchyFailure;
exports.editMetadataRow = editMetadataRow;
exports.batchEditMetadataRow = batchEditMetadataRow;
exports.overrideColumns = overrideColumns;
exports.validateMetadataFormRequest = validateMetadataFormRequest;
exports.validateMetadataFormFailure = validateMetadataFormFailure;
exports.validateMetadataFormSuccess = validateMetadataFormSuccess;
exports.saveMetadataFormRequest = saveMetadataFormRequest;
exports.saveMetadataFormFailure = saveMetadataFormFailure;
exports.saveMetadataFormSuccess = saveMetadataFormSuccess;
exports.importMetadataRequest = importMetadataRequest;
exports.importMetadataFailure = importMetadataFailure;
exports.importMetadataSuccess = importMetadataSuccess;
var ActionTypes = require("actionTypes/metadataEditor");
function fetchHierarchyRequest(uuid, hierarchyType) {
    return {
        type: ActionTypes.FETCH_METADATA_EDITOR_HIERARCHY_REQUEST,
        uuid: uuid,
        hierarchyType: hierarchyType
    };
}
function fetchHierarchySuccess(payload) {
    return {
        type: ActionTypes.FETCH_METADATA_EDITOR_HIERARCHY_SUCCESS,
        data: payload
    };
}
function fetchHierarchyFailure(error) {
    return {
        type: ActionTypes.FETCH_METADATA_EDITOR_HIERARCHY_FAILURE,
        payload: error
    };
}
function editMetadataRow(uuid, field) {
    return {
        type: ActionTypes.EDIT_METADATA_ROW,
        uuid: uuid,
        field: field
    };
}
function batchEditMetadataRow(rows) {
    return {
        type: ActionTypes.BATCH_EDIT_METADATA_ROW,
        rows: rows
    };
}
function overrideColumns(field) {
    return {
        type: ActionTypes.OVERRIDE_COLUMNS,
        field: field
    };
}
function validateMetadataFormRequest() {
    return {
        type: ActionTypes.VALIDATE_METADATA_EDITOR_REQUEST
    };
}
function validateMetadataFormFailure(columns, rows, errRows) {
    return {
        type: ActionTypes.VALIDATE_METADATA_EDITOR_FAILURE,
        columns: columns,
        rows: rows,
        errRows: errRows
    };
}
function validateMetadataFormSuccess() {
    return {
        type: ActionTypes.VALIDATE_METADATA_EDITOR_SUCCESS
    };
}
function saveMetadataFormRequest(request) {
    return __assign({ type: ActionTypes.SAVE_METADATA_EDITOR_REQUEST }, request);
}
function saveMetadataFormFailure(error) {
    return {
        type: ActionTypes.SAVE_METADATA_EDITOR_FAILURE,
        payload: error
    };
}
function saveMetadataFormSuccess() {
    return {
        type: ActionTypes.SAVE_METADATA_EDITOR_SUCCESS
    };
}
function importMetadataRequest(file) {
    return {
        type: ActionTypes.IMPORT_METADATA_REQUEST,
        file: file
    };
}
function importMetadataFailure() {
    return {
        type: ActionTypes.IMPORT_METADATA_FAILURE
    };
}
function importMetadataSuccess(isValid) {
    return {
        type: ActionTypes.IMPORT_METADATA_SUCCESS,
        isValid: isValid
    };
}
